// extracted by mini-css-extract-plugin
module.exports = {"title":"ReviewAggregate_title__u7eG8","subtitle":"ReviewAggregate_subtitle__oDdmu"};